
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/enroll",
      function () {
        return require("private-next-pages/[market]/[language]/enroll.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/enroll"])
      });
    }
  